import { REGEX } from "../constants/regex";
import { startLoader, stopLoader } from "../util/loader"
import { NearbyLocations } from "../util/nearbyLocations";
import { getFranchiseDetails } from "../util/share";
export class FindUsAddressBumper {
  private readonly sendButton: HTMLButtonElement | null;
  private readonly formElement: HTMLFormElement;
  private readonly steps: any;
  private zipCodeValue: string = ""; // Store ZIP Code
  private readonly handleClose;
  constructor() {
    this.steps = {
      step1: document.querySelector(".dynamic-step-1"),
      step2: document.querySelector(".dynamic-step-2"),
      step3: document.querySelector(".dynamic-step-3"),
      step4: document.querySelector(".dynamic-step-4"),
      step5: document.querySelector(".dynamic-step-5"),
  };
     this.formElement = document.querySelector('.dynamic-step-2 .modal-search') as HTMLFormElement;
    this.sendButton = document.querySelector('.dynamic-step-2 .form-cta button');
    if (this.sendButton) {
      this.sendButton.addEventListener("click", this.handleNextBtnClick.bind(this));
    }
    const closeButton = document.querySelector('#dynamic-close-local-modal');
    this.handleClose = this.handleModalClose.bind(this);
    if (closeButton) {
      closeButton.addEventListener('click', this.handleClose);
    }
    const dynaicCloseButton = document.querySelector('#dynamic-close-btn-error');
    if (dynaicCloseButton) {
      dynaicCloseButton.addEventListener('click', () => {
        this.resetModalClose();
      });
    }
    this.setupInlineValidation();
  }


  private resetModalClose() {
    this.formElement.reset();
    this.steps.step4.classList.add('hidden');
    this.steps.step1.classList.remove('hidden');
  }
  private setupInlineValidation(): void {
    const fields = {
      address1: document.querySelector('.dynamic-step-2 #dynamic-modal-address-1') as HTMLInputElement,
      address2: document.querySelector('.dynamic-step-2 #dynamic-modal-address-2') as HTMLInputElement,
      city: document.querySelector('.dynamic-step-2 #dynamic-modal-city') as HTMLInputElement,
      state: document.querySelector('.dynamic-step-2 #dynamic-modal-state') as HTMLSelectElement,
      zipCode: document.querySelector('.dynamic-step-2 #dynamic-modal-zipcode') as HTMLInputElement
    };

    fields.address1?.addEventListener('input', (e) => this.validateField(e.target as HTMLInputElement, () => this.addressValidation(fields.address1.value, true)));
    fields.address2?.addEventListener('input', (e) => this.validateField(e.target as HTMLInputElement, () => this.addressValidation(fields.address2.value, false)));
    fields.city?.addEventListener('input', (e) => this.validateField(e.target as HTMLInputElement, () => this.cityValidation(fields.city.value)));
    fields.zipCode?.addEventListener('input', (e) => this.validateField(e.target as HTMLInputElement, () => this.zipValidation(fields.zipCode.value)));
    fields.state?.addEventListener('change', (e) => this.validateField(e.target as HTMLSelectElement, () => this.stateValidation(fields.state.value)));
  }

  private validateField(element: HTMLInputElement | HTMLSelectElement, validationFunction: () => string): void {
    const error = validationFunction();
    const errorElement = element.nextElementSibling as HTMLSpanElement;
    if (error) {
      element.classList.add('invalid-field');
      if (errorElement?.classList.contains('error-msg')) {
        errorElement.textContent = error;
      } else {
        const newErrorElement = document.createElement('span');
        newErrorElement.className = 'error-msg';
        newErrorElement.textContent = error;
        element.parentNode?.insertBefore(newErrorElement, element.nextSibling);
      }
    } else {
      element.classList.remove('invalid-field');
      if (errorElement?.classList.contains('error-msg')) {
        errorElement.remove();
      }
    }
  }

  private getFormFields(): any {
    const fields = {

      zipCode: (document.querySelector('.dynamic-step-2 #dynamic-modal-zipcode') as HTMLInputElement).value,
      address1: (document.querySelector('.dynamic-step-2 #dynamic-modal-address-1') as HTMLInputElement).value,
      address2: (document.querySelector('.dynamic-step-2 #dynamic-modal-address-2') as HTMLInputElement).value,
      city: (document.querySelector('.dynamic-step-2 #dynamic-modal-city') as HTMLInputElement).value,
      state: (document.querySelector('.dynamic-step-2 #dynamic-modal-state') as HTMLSelectElement).value,
    };
    return fields;
  }

  private addressValidation(inputVal: string, isRequired: boolean): string {
    const addrRegex = REGEX.noBracketAddress;
    if (isRequired) {
      if (!inputVal.trim()) {
        return 'Address Line 1 is required.';
      }
      if (!addrRegex.test(inputVal)) {
        return 'Enter valid address.';
      }
    } else if (inputVal.trim() && !addrRegex.test(inputVal)) {
        return 'Enter valid address.';
    }
    return '';
  }

  private zipValidation(inputVal: string): string {
    const zipRegex = REGEX.sendZip;
    if (!inputVal.trim()) {
      return 'Zip code is required.';
    }
    if (!zipRegex.test(inputVal.trim()) || inputVal.trim() === '00000') {
      return 'Invalid zip code format.';
    }
    return '';
  }

  private cityValidation(inputVal: string): string {
    const cityRegex = REGEX.sendName;
    if (!inputVal.trim()) {
      return 'City is required.';
    }
    if (!cityRegex.test(inputVal)) {
      return 'Enter valid city.';
    }
    return '';
  }

  private stateValidation(inputVal: string): string {
    if (!inputVal || inputVal === '') {
      return 'State is required.';
    }
    return '';
  }


  public validateForm(): boolean {
    const formFields = this.getFormFields();

    let errors: { [key: string]: string } = {};
    errors['dynamic-modal-address-1'] = this.addressValidation(formFields.address1, true);
    errors['dynamic-modal-address-2'] = this.addressValidation(formFields.address2, false);
    errors['dynamic-modal-zipcode'] = this.zipValidation(formFields.zipCode);
    errors['dynamic-modal-city'] = this.cityValidation(formFields.city);
    errors['dynamic-modal-state'] = this.stateValidation(formFields.state);

    Object.keys(errors).forEach((fieldId) => {
      const field = document.getElementById(fieldId) as HTMLSpanElement | null;

      if (!field?.parentNode) return;

      const errorMessage = errors[fieldId];
      if (!errorMessage) return;

      // Check if an error message span already exists
      let errorElement = field.parentNode.querySelector('.error-msg');
      if (!errorElement) {
        // Create the span element if not found
        const errorElement = document.createElement('span');
        errorElement.className = 'error-msg';
        errorElement.textContent = errorMessage;
        field.parentNode.appendChild(errorElement);
      } else {
        //Use existing span element to show the error message
        if (errorElement && errorMessage) {
          errorElement.innerHTML = errorMessage;
        }
        if (errorElement?.classList?.contains('hidden')) {
          errorElement.classList.remove('hidden');
        }
      }
      field.classList.add("invalid-field");
    });

    return Object.values(errors).every(error => !error);
  }

  public handleNextBtnClick(): void {
   if (this.validateForm()) {
      startLoader()
      this.handleNextBtnSubmit()
    }
  }

  public handleNextBtnSubmit(): void {
    const inputAddressBumper = document.querySelector('.dynamic-step-2 #dynamic-modal-address-1') as HTMLInputElement;
    const inputAddressBumper2 = document.querySelector('.dynamic-step-2 #dynamic-modal-address-2') as HTMLInputElement;
    const inputCity = document.querySelector('.dynamic-step-2 #dynamic-modal-city') as HTMLInputElement;
    const inputState1 = document.querySelector('.dynamic-step-2 #dynamic-modal-state') as HTMLInputElement;
    const inputZipCode = document.querySelector('.dynamic-step-2 #dynamic-modal-zipcode') as HTMLInputElement;
    const sAddressBumper = inputAddressBumper?.value.trim() || '';
    const sAddressBumper1 = inputAddressBumper2?.value.trim() || '';
    const sCityBumper = inputCity?.value.trim() || '';
    const sStateBumper = inputState1?.value.trim() || '';
    const sZipCodeBumper = inputZipCode?.value.trim() || '';
    const sAddressParam = `${sAddressBumper} ${sAddressBumper1} ${sCityBumper} ${sStateBumper} ${sZipCodeBumper}`;
    this.zipCodeValue = inputZipCode?.value.trim() || ""; // Store it before modal closes
    getFranchiseDetails(sAddressParam) // RoundRobin is true
      .then((result) => {
     
                if (result.length === 0) {
                    this.handleNoResults();
                    return;
                }
               const happyText = document.querySelector(".dynamic-step-5 .happy-text");
                if (!happyText) { return };
                const steps = document.querySelectorAll(".dynamic-step-1, .dynamic-step-2, .dynamic-step-3, .dynamic-step-4");
                steps?.forEach(step => step.classList.add("hidden")); // Hide all steps
                this.steps.step5?.classList.remove("hidden");
                const zipCodeSpan = document.querySelector(".dynamic-step-5 .happy-text span") as HTMLElement;
                if (zipCodeSpan && sZipCodeBumper) {
                    stopLoader();
                    zipCodeSpan.textContent = sZipCodeBumper; // Replace with actual ZIP code
                }
                const heading = document.querySelector('.dynamic-step-5 .heading-container h3') as HTMLElement;
                const phoneWrapper = document.querySelector('.dynamic-step-5 .phone-num-wrapper') as HTMLAnchorElement;
                const websiteLink = document.querySelector('.dynamic-step-5 .view-web-link') as HTMLAnchorElement;

                // Format phone number for `tel:` link
                const formattedPhone = result[0].phoneNumber.replace(/\D/g, "");
                const phoneFormat: any = result[0].phoneNumber
                ? `(${result[0].phoneNumber.slice(0, 3)}) ${result[0].phoneNumber.slice(3, 6)}-${result[0].phoneNumber.slice(6)}`
                : null;
                // Update content if elements exist
                if (heading) heading.textContent = result[0].doingBusinessAs;
                if (phoneWrapper) {
                    phoneWrapper.href = `tel:${formattedPhone}`;
                    phoneWrapper.innerHTML = `
                <svg class="h-6 w-6">
                    <use xlink:href="/_assets-global/images/hero-icon-sprite.svg#phone-outline-primary"></use>
                </svg>
                ${phoneFormat}
            `;
                }
                if (websiteLink) {
                    websiteLink.href = result[0].locationWebsiteUrl;
                }

      
      })

  }
  handleNoResults() {
    const zip = document.querySelector('.dynamic-step-2 #dynamic-modal-zipcode') as HTMLInputElement
    const zipCode = zip?.value.trim();
    if (zipCode) {this.handleNearbyLocationsFlow(zipCode);
    stopLoader();
    }
}

private handleNearbyLocationsFlow(inputArg: any) {
  let franchiseLimit: number, units: string, nearbyLocations;
  let flag = true;
  if (flag) {
      units = "50miles";
      franchiseLimit = 50;
      this.callNearbyLocations(units, franchiseLimit, inputArg);
  }
  else {
      this.handleErrorScenario(inputArg);
  }

}
private handleErrorScenario(zipCode: string) {
  this.steps.step2.classList.add('hidden');
  const errorModal = document.querySelector('.dynamic-step-4') as HTMLElement;
  if (errorModal) {
      errorModal.classList.remove('hidden');

      // Update error message with ZIP code
      const errorMessage = errorModal.querySelector('.modal-text') as HTMLElement;
      if (errorMessage) {
          errorMessage.textContent = `We’re sorry. We don’t currently provide service to ${this.zipCodeValue}.`;
      }
    }

}
private callNearbyLocations(units: string, franchiseLimit: number, zipCode: string) {
  new NearbyLocations(units, franchiseLimit).searchNearbyLocations(zipCode)
      .then(this.displayNearbyLocations.bind(this))
      .catch(() => this.handleErrorScenario(zipCode));
}

private displayNearbyLocations(data: any) {
  if (!data.length) return this.handleErrorScenario(data);

  Object.values(this.steps).forEach(step => (step as HTMLElement)?.classList.add("hidden"));
   // Handle dynamic-step-5 updates
   const firstLocation = data[0];
   if (firstLocation) {
       const step5 = document.querySelector(".dynamic-step-5");
       step5?.classList.remove("hidden");

       const notFoundWrapper = this.steps.step5.querySelector(".loc-not-found-wrapper");
       notFoundWrapper?.classList.remove("hidden");
       // Update ZIP code inside loc-not-found-wrapper
       const notFoundZipSpan = document.querySelector(".loc-not-found-wrapper p span");
       if (notFoundZipSpan && this.zipCodeValue) {
           notFoundZipSpan.textContent = this.zipCodeValue;
       }
       this.steps.step5.querySelector(".not-found-text")?.classList.remove("hidden");
       this.steps.step5.querySelector(".happy-text")?.classList.add("hidden");

       this.steps.step5.querySelector(".heading-container h3")!.textContent = firstLocation.doingBusinessAs;
       this.steps.step5.querySelector(".view-web-link")!.setAttribute("href", firstLocation.websiteUrl);
       this.steps.step5.querySelector(".phone-num-wrapper")!.setAttribute("href", `tel:${firstLocation.phoneNumber.replace(/\D/g, "")}`);
       this.steps.step5.querySelector(".phone-num-wrapper")!.innerHTML = `
       <svg class="h-6 w-6">
           <use xlink:href="/_assets-global/images/hero-icon-sprite.svg#phone-outline-primary"></use>
       </svg>
       (${firstLocation.phoneNumber.slice(0, 3)}) ${firstLocation.phoneNumber.slice(3, 6)}-${firstLocation.phoneNumber.slice(6)}
  `;
   }
}
  private clearValidationErrors(): void {
    document.querySelectorAll('.dynamic-step-2 .error-msg').forEach(e => e.remove());
    document.querySelectorAll('.dynamic-step-2 .invalid-field').forEach(e => e.classList.remove('invalid-field'));
  }

  private handleModalClose(): void {
    this.formElement.reset();
    this.clearValidationErrors();
    const closeButton = document.getElementById('dynamic-close-local-modal') as HTMLButtonElement | null;
    if(closeButton) {
      closeButton.removeEventListener('click', this.handleClose);
    }
  }

}